import { render } from "./MyWarnings.vue?vue&type=template&id=c8f9e40e&scoped=true"
import script from "./MyWarnings.vue?vue&type=script&lang=js"
export * from "./MyWarnings.vue?vue&type=script&lang=js"

import "./MyWarnings.vue?vue&type=style&index=0&id=c8f9e40e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f9e40e"]])

export default __exports__